import React, { createContext, useContext, useState, useEffect, useMemo } from 'react';
import axios from 'axios';

const AdminAuthContext = createContext(null);
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function AdminAuthProvider({ children }) {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('nli_admin_token');
    const username = localStorage.getItem('nli_admin_user');
    if (token && username) {
      // Verify token is still valid
      axios.get(`${API}/admin/me`, { headers: { Authorization: `Bearer ${token}` } })
        .then(() => setAdmin({ token, username }))
        .catch(() => { localStorage.removeItem('nli_admin_token'); localStorage.removeItem('nli_admin_user'); })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (username, password) => {
    const res = await axios.post(`${API}/admin/login`, { username, password });
    const { token } = res.data;
    localStorage.setItem('nli_admin_token', token);
    localStorage.setItem('nli_admin_user', username);
    setAdmin({ token, username });
    return res.data;
  };

  const logout = () => {
    localStorage.removeItem('nli_admin_token');
    localStorage.removeItem('nli_admin_user');
    setAdmin(null);
  };

  const authHeaders = useMemo(
    () => (admin ? { Authorization: `Bearer ${admin.token}` } : {}),
    [admin]
  );

  return (
    <AdminAuthContext.Provider value={{ admin, login, logout, loading, authHeaders }}>
      {children}
    </AdminAuthContext.Provider>
  );
}

export function useAdminAuth() {
  return useContext(AdminAuthContext);
}
